import Image from 'next/image';
import cx from 'classnames';

import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';

type IInputSearchCardProps = {
  destinations: IZoneWithDestinationsAndPromo[];
  hide: boolean;
  onRedirect: (url: string) => void;
};

export const InputSearchDestinationCard = ({
  destinations,
  hide,
  onRedirect,
}: IInputSearchCardProps) => {
  return (
    <div
      className={cx(
        hide ? 'hidden' : 'block',
        'no-scrollbar absolute inset-x-0 top-[60px] z-10 max-h-[190px] cursor-pointer overflow-y-scroll rounded-lg border bg-white p-0.5'
      )}
    >
      {destinations.map(item => {
        if (item.id.toLowerCase() === 'aeromobile') return;

        return (
          <button
            key={item.name}
            onClick={() => onRedirect(item.url)}
            className={
              'flex w-full items-center gap-2 rounded-lg p-4 px-6 hover:bg-overlay'
            }
          >
            <Image
              src={`/static/flags/${item.flagName}`}
              alt={item.name}
              width={24}
              height={24}
            />
            <p className={'font-semibold'}>{item.name}</p>
          </button>
        );
      })}
    </div>
  );
};
